import { ChangeDetectorRef, Directive, inject, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ResponsiveService } from '../../../services/responsive/responsive.service';

@Directive({
  selector: '[appNgIfPhoneAndTablet]',
  standalone: true,
})
export class NgIfPhoneAndTabletDirective implements OnInit, OnDestroy {
  // Only here to avoid getting an error because we need to bind to 'appNgIfPhoneAndTablet'
  // in order to be able to bind to 'else'
  @Input('appNgIfPhoneAndTablet') _?: any;

  /**
   * Template used when the site is NOT being viewed on a phone or tablet
   * 
   * @example
   * <div *appNgIfPhoneAndTablet="''; else: backup"></div>
   * 
   * <ng-template #backup></ng-template>
   */
  @Input('appNgIfPhoneAndTabletElse') elseTemplateRef?: TemplateRef<unknown>

  private readonly responsiveService = inject(ResponsiveService);
  private readonly templateRef: TemplateRef<unknown> = inject(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  private subscription!: Subscription;

  ngOnInit(): void {
    this.subscription = this.responsiveService.isMobileOrTablet$.subscribe((isMobileOrTablet) => {
      this.viewContainer.clear();

      if (isMobileOrTablet) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else if (this.elseTemplateRef) {
        this.viewContainer.createEmbeddedView(this.elseTemplateRef);
      }
      
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
